// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3M4l5","head":"ProcedureTableInfo_head__Sv29t"};